import React, { useState, useEffect } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { blueGrey } from '@material-ui/core/colors';
import InputForm from '../../../components/Forms/InputForm';
import DisplayError from '../../../components/DisplayError';
import RoundedButton from '../../../components/Actions/RoundedButton';
import InputSelectForm from '../../../components/Forms/InputSelectForm';


const RequestPhoneCode = (props) => {

    const {system, form, actions} = props

    return ( 
        <div>
            <Typography  variant='h5' style={{fontWeight:600,marginBottom:24}}>Forgot Password</Typography>
            <div>
                <Typography style={{color:blueGrey[500]}}>
                    Enter the email and the phone number you use to sign in to Flexia Dashboard and we'll send you a code to your phone to reset your password
                </Typography>
                <div style={{padding:'24px 0px'}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <InputForm data={form.email} onChange={actions.onChangeForm} />
                        </Grid>
                        <Grid item xs={3}>
                            <InputSelectForm data={form.countryCode} onChange={actions.onChangeForm} />
                        </Grid>
                        <Grid item xs={9}>
                            
                            <InputForm data={form.phoneNumber} onChange={actions.onChangeForm} />
                        </Grid>
                    </Grid>
                </div>
                <div style={{marginTop:32, textAlign:'center'}}>
                    <DisplayError>{system.error}</DisplayError>
                    <RoundedButton loading={system.loading} onClick={actions.onRequestCode}>Request code</RoundedButton>
                </div>
            </div>
            
        </div>
     );
}

const useStyles = makeStyles(theme => ({

}))
 
export default RequestPhoneCode;